<template>
  <div v-if="authenticatedUser">
    <b-container>
      <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
        <b-row class="pl-3 pr-3 pt-4">
          <h3 class="text-left">Add a new Organisation</h3>
        </b-row>
        <hr>
        <b-row>
          <b-col cols-6 class="my-container">
            <b-form>
              <b-form-group>
                <label class="d-block text-left text-bold">Organisation name <span class="text-danger">*</span></label>
<!--                <b-form-input-->
<!--                  placeholder="Enter the organisation's name"-->
<!--                  v-model="EF.name">-->
<!--                </b-form-input>-->
                <OrgNameAutoComplete/>
                <b-alert dismissible style="width: 100%" v-model="emptyTitleAlert" variant="danger">
                  You have to provide a title!
                </b-alert>
              </b-form-group>
              <b-form-group>
                <label class="d-block text-left text-bold">About <span class="text-danger">*</span></label>
                <textarea
                  class="col-12 form-control textareaDescription"
                  placeholder="Enter the organisation's description"
                  v-model="EF.description">
                </textarea>
                <b-alert dismissible style="width: 100%" v-model="emptyDescriptionAlert" variant="danger">
                  You have to provide a description!
                </b-alert>
              </b-form-group>
              <b-form-group>
                  <label class="d-block text-left text-bold">Type
                    <span class="text-danger">*</span>
                  </label>
                  <select v-model="EF.type[0]" class="custom-select d-block">
                    <option value="" disabled>Select type</option>
                    <option value="Central government"> Central government</option>
                    <option value="Charity or foundation">Charity or foundation</option>
                    <option value="For-profit organisation">For-profit organisation</option>
                    <option value="GLAM (Galleries, Libraries, Archives, Museums)">GLAM (Galleries, Libraries, Archives, Museums)</option>
                    <option value="Informal group or association">Informal group or association</option>
                    <option value="International body">International body</option>
                    <option value="Local government">Local government</option>
                    <option value="Non-Governmental Organisation">Non-Governmental Organisation</option>
                    <option value="Regional government">Regional government</option>
                    <option value="Religious institution">Religious institution</option>
                    <option value="School">School</option>
                    <option value="University or research institute">University or research institute</option>
                    <option value="Other">Other (specify)</option>
                  </select>
                  <b-form-group class="mt-4" v-if="this.EF.type.includes('Other')">
                    <label class="d-block text-left text-bold">Please specify</label>
                    <b-form-input
                      placeholder="Enter the type of the organisation"
                      v-model="additionalType"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-alert dismissible style="width: 100%" v-model="emptyTypeAlert" variant="danger">
                    You have to provide a type!
                  </b-alert>
              </b-form-group>
              <b-form-group label="Website" label-align="left" label-for="input-2">
                <b-form-input
                  placeholder="Enter the organisation's website"
                  v-model="EF.url"
                  rows-1>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Organisation banner" label-align="left" class="mt-2 mb-3">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  placeholder="Browse your files..."
                  drop-placeholder="Drop file here..."
                  class="text-left">
                </b-form-file>
              </b-form-group>
              <b-form-group label="Keywords" label-align="left" label-for="input-2">
                <tags-input
                  placeholder="  Enter keywords as tags"
                  element-id="keywords"
                  v-model="EF.keywords"
                  :typeahead="true">
                </tags-input>
                <p class="text-left font-italic" style="color: red; font-size: 14px">* Press enter after each keyword.</p>
              </b-form-group>
              <b-form-group label="Notes" label-align="left" label-for="input-2">
                <b-row>
                </b-row>
                <textarea
                  class="col-12 form-control"
                  placeholder="Enter notes"
                  rows="4" v-model="EF.notes">
                </textarea>
              </b-form-group>
<!--              <b-form-group label="Offers" label-align="left" label-for="input-2">-->
<!--              <b-form-group label="Services" label-align="left" label-for="input-2">-->
<!--                <tags-input-->
<!--                  placeholder="  Enter services as tags"-->
<!--                  element-id="offers"-->
<!--                  v-model="EF.offers"-->
<!--                  :typeahead="true">-->
<!--                </tags-input>-->
<!--              </b-form-group>-->
<!--              <b-form-group label="Interest" label-align="left" label-for="input-2">-->
<!--                <tags-input-->
<!--                  placeholder="  Enter interests as tags"-->
<!--                  element-id="interest"-->
<!--                  v-model="EF.interest"-->
<!--                  :typeahead="true">-->
<!--                </tags-input>-->
<!--              </b-form-group>-->
            </b-form>
          </b-col>
          <b-col cols-6>
            <b-form>
              <b-form-group>
                <label class="d-block text-left text-bold">Services</label>
                <textarea
                  class="col-12 form-control textareaDescription"
                  placeholder="Enter the organisation's services"
                  v-model="EF.services">
                </textarea>
              </b-form-group>
              <b-form-group label="Address" label-align="left" label-for="input-2">
                <b-form-input
                  placeholder="Enter address"
                  v-model="EF.address"
                  rows-1>
                </b-form-input>
              </b-form-group>
              <b-form-group label="City" label-align="left" label-for="input-2">
                <b-form-input
                  placeholder="Enter city"
                  v-model="EF.city"
                  rows-1>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Country" label-align="left" label-for="input-2">
                <b-form-input
                  placeholder="Enter country"
                  v-model="EF.country"
                  rows-1>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Telephone" label-align="left" label-for="input-2">
                <vue-tel-input v-bind="bindProps" v-model="EF.telephone"></vue-tel-input>
              </b-form-group>
              <b-form-group label="Contact" label-align="left" label-for="input-2">
                <b-form-input
                  placeholder="Enter contact info"
                  v-model="EF.contact"
                  rows-1>
                </b-form-input>
              </b-form-group>
              <br>
              <br>
              <b-container>
                <b-row>
                  <b-container class="my-container text-left">
                    <label>Public</label>
                    <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="EF.publicReadable">
                      Yes
                    </b-form-checkbox>
                  </b-container>
                </b-row>
              </b-container>
            </b-form>
          </b-col>
        </b-row>
        <br>
        <hr>
        <b-row align-h="start" class="ml-3">
          <h6><span class="text-danger">*</span> Required field </h6>
        </b-row>
        <b-row>
          <b-alert dismissible style="width: 100%" v-model="showDismissibleAlert" variant="danger">
            You must fill in all the required fields!
          </b-alert>
        </b-row>

        <b-row class="p-3 mb-4">
          <div class="float-right">
            <router-link :to="{name: 'organizations' }">
              <b-button class="link">Cancel</b-button>
            </router-link>
            <button @click="checkForm" class="btn bg-orange" style="margin: 0" type="button">
              Save
            </button>
          </div>
        </b-row>
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess></NoAccess>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NoAccess from '../components/NoAccess'
import OrgNameAutoComplete from '../components/organizations/OrgNameAutoComplete';
import {eventBus} from "../main";

export default {
  components: {
    OrgNameAutoComplete,
    NoAccess
  },
  data () {
    return {
      bindProps: {
        mode: 'international',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: 'Enter a phone number',
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        onlyCountries: [],
        ignoredCountries: [],
        maxLen: 25,
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        }
      },

      // Additional Type when the user chooses 'Other'
      additionalType: '',

      // Empty fields variables
      showDismissibleAlert: false,
      emptyTitleAlert: false,
      emptyDescriptionAlert: false,
      emptyTypeAlert: false,

      file: null,
      saveAction: false,

      keywords1: '',
      EF: {
        publicReadable: true,
        description: '',
        type: [],
        url: '',
        name: '',
        country: '',
        city: '',
        address: '',
        telephone: '',
        contact: '',
        services: '',
        notes: '',
        keywords: []
      },
      contactWarning: false
    }
  },
  created () {
    eventBus.$on('organisationName', (data) => {
      this.EF.name = data
    })
  },
  beforeRouteLeave (to, from, next) {
    if (!this.saveAction) {
      this.boxOne = ''
      this.$bvModal.msgBoxConfirm('Are you sure you want to leave without saving? If you do, all your work will be lost.', {
        title: 'Warning',
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            next()
          } else {
            next(false)
          }
        })
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
    } else {
      next()
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ]),
    ContactM () {
      let ContactM = []
      ContactM.push(this.EF.contact)
      return ContactM
    },
    NewKeywordsArray () {
      let NewKeywordsArray = []
      for (let i = 0; i < this.EF.keywords.length; i++) {
        NewKeywordsArray.push(this.EF.keywords[i].value)
      }
      return NewKeywordsArray
    },
    NewOffersArray () {
      let NewOffersArray = []
      for (let i = 0; i < this.EF.offers.length; i++) {
        NewOffersArray.push(this.EF.offers[i].value)
      }
      return NewOffersArray
    }
    // NewInterestArray () {
    //   let NewInterestArray = []
    //   for (let i = 0; i < this.EF.interest.length; i++) {
    //     NewInterestArray.push(this.EF.interest[i].value)
    //   }
    //   return NewInterestArray
    // }
  },
  methods: {
    checkForm () {
      this.showDismissibleAlert = false
      this.emptyTitleAlert = false
      this.emptyDescriptionAlert = false
      this.emptyTypeAlert = false

      if (!this.EF.name || !this.EF.description || this.EF.type.length === 0) {
        this.showDismissibleAlert = true
        if (!this.EF.name) {
          this.emptyTitleAlert = true
        }
        if (!this.EF.description) {
          this.emptyDescriptionAlert = true
        }
        if (this.EF.type.length === 0) {
          this.emptyTypeAlert = true
        }
      } else {
        if (this.EF.type.includes('Other') && !this.additionalType) {
          this.emptyTypeAlert = true
        } else {
          this.showMsgContactInfo()
        }
      }
    },
    showMsgSuccess () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Your organisation has been successfully created.', {
        okVariant: 'success'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            this.$router.push({ name: 'organizations' })
          } else {}
        })
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
    },
    showMsgFail () {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Something went wrong. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
            // window.location.reload()
          } else {}
        })
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
    },
    showMsgContactInfo () {
      if (!this.contactWarning && this.EF.url === '' && this.EF.contact === '') {
        this.boxOne = ''
        this.$bvModal.msgBoxConfirm('You have not entered a website or contact info. Adding this information is important for organisations to be found. Are you sure you wish to proceed?', {
          okVariant: 'info'
        })
          .then(value => {
            this.boxOne = value
            if (this.boxOne) {
              this.contactWarning = true
              this.registerOrganisation()
            } else {
              this.contactWarning = true
            }
          })
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
      } else {
        this.registerOrganisation()
      }
    },
    registerOrganisation () {
      this.saveAction = true

      if (this.EF.type.includes('Other')) {
        this.EF.type.push(this.additionalType)
      }

      let InputCollaboratorData = {
        'publicReadable': this.EF.publicReadable,
        'description': this.EF.description,
        'type': this.EF.type,
        'url': this.EF.url,
        'name': this.EF.name,
        'country': this.EF.country,
        'city': this.EF.city,
        'address': this.EF.address,
        'contact': this.ContactM,
        // 'interest': this.NewInterestArray,
        'services': this.EF.services,
        'notes': this.EF.notes,
        'telephone': this.EF.telephone,
        'keywords': this.NewKeywordsArray,
        'metadataLanguage': 'string'
      }

      if (this.EF.country === '' || this.EF.country === null || this.EF.country === undefined) {
        delete InputCollaboratorData.country
      }
      if (this.EF.url === '' || this.EF.url === null || this.EF.url === undefined) {
        delete InputCollaboratorData.url
      }
      if (this.EF.city === '' || this.EF.city === null || this.EF.city === undefined) {
        delete InputCollaboratorData.city
      }
      if (this.EF.address === '' || this.EF.address === null || this.EF.address === undefined) {
        delete InputCollaboratorData.address
      }
      if (this.EF.contact === '' || this.EF.contact === null || this.EF.contact === undefined) {
        delete InputCollaboratorData.contact
      }
      if (this.EF.notes === '' || this.EF.notes === null || this.EF.notes === undefined) {
        delete InputCollaboratorData.notes
      }
      if (this.EF.keywords.length === 0) {
        delete InputCollaboratorData.keywords
      }
      if (this.EF.services === '' || this.EF.services === null || this.EF.services === undefined) {
        delete InputCollaboratorData.services
      }

      this.$store.dispatch('createCollaborator', InputCollaboratorData).then(
        organisation => {
          if (organisation) {
            if (this.file !== null) {
              let formData = new FormData()
              formData.append('file', this.file)
              let params = {id: organisation.id, file: formData}
              this.$store.dispatch('uploadOrganisationBanner', params).then(
                data => {
                  this.showMsgSuccess()
                }
              ).catch((error) => {
                console.info(error)
                this.showMsgFail()
              })
            } else {
              this.showMsgSuccess()
            }
          } else {
            this.showMsgFail()
          }
        }
      ).catch((error) => {
        console.info(error)
        this.showMsgFail()
      })
    }
  }
}
</script>

<style scoped>
  .label-align-left {
    float: left
  }

  .textareaDescription {
    height: 210px
  }

  .inputTypeWidth {
    width: 460px
  }
</style>



// WEBPACK FOOTER //
// src/views/OrganizationAdd.vue